import { httpClient } from "./httpClient";
import dayjs from "dayjs";

const getSummaryTime = (search, query) => {
  return httpClient.get(
    `/report/summary-time?start=${search.start}&end=${search.end}`,
    { params: query }
  );
};

export default {
  getSummaryTime,
};
